"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contextSetUnmappedView = exports.contextSetGuestUserLoginToastInfo = exports.contextRegisterSectionId = exports.contextSetShowCommentId = exports.contextSetClickedAnnotation = exports.contextSaveImageCoordinatesInfo = exports.contextSaveFocusedInputInfo = exports.contextSaveAnnotationColor = exports.contextSaveAnnotationLocation = exports.setAnnotatingCommentId = exports.toggleAnnotationMode = exports.contextSetAnnotationMode = exports.contextSetCommentsListMinimized = exports.contextResetGuestUserSession = exports.contextCreateGuestUserSession = void 0;

var _commentsSdk = require("@ccx-public/comments-sdk");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FIVE_MIN = 300000;
var ON_HOUR = FIVE_MIN * 12;
var expireSoonTimer;
var expiredTimer;
/**
 * Action to create guest session
 * @param {Object} data - user data required to create guest session
 * @param {Boolean} isRestoringGuestSession - flag if we need to restore existing session
 * @return {undefined}
 */

var contextCreateGuestUserSession = function contextCreateGuestUserSession(data, isRestoringGuestSession) {
  return function (dispatch, getState) {
    var state = getState();
    var context = (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context"));
    var guestSessionRestoreCount = context.guestSessionRestoreCount; // clear any existing session timers

    clearTimeout(expireSoonTimer);
    clearTimeout(expiredTimer);
    return new Promise(function (resolve, reject) {
      _commentsSdk.Client.instance.createAnonymousSession(data, isRestoringGuestSession).then(function (resp) {
        var expires = resp.expires,
            imsData = _objectWithoutProperties(resp, ["expires"]);

        _commentsSdk.Client.instance.configure({
          token: imsData.token
        });

        var guestInfo = _objectSpread(_objectSpread({}, imsData), {}, {
          name: data.userName
        });

        dispatch({
          data: guestInfo,
          type: _constants.CONTEXT_CREATE_GUEST_USER_SESSION.SUCCESS
        });
        var curTimestamp = new Date();
        var expireTimestamp = new Date(parseInt(expires, 10));
        var hourFromNow = new Date(+curTimestamp + ON_HOUR); // Server time vs client time - determine if within acceptable window before setting up expiry logic

        if (expireTimestamp > new Date(+hourFromNow - FIVE_MIN) && expireTimestamp < new Date(+hourFromNow + FIVE_MIN)) {
          var expireTimeout = Math.min(expireTimestamp, hourFromNow) - curTimestamp; // Use closer date when determining end of session

          if (guestSessionRestoreCount > 0) {
            expireSoonTimer = setTimeout(function () {
              dispatch({
                type: _constants.CONTEXT_SET_GUEST_USER_SESSION_STATE,
                sessionState: 'expires-soon'
              });
            }, expireTimeout - FIVE_MIN);
          }

          expiredTimer = setTimeout(function () {
            dispatch({
              type: _constants.CONTEXT_SET_GUEST_USER_SESSION_STATE,
              sessionState: 'expired'
            });
          }, expireTimeout);
        }

        resolve(guestInfo);
      }).catch(function (error) {
        dispatch({
          type: _constants.CONTEXT_CREATE_GUEST_USER_SESSION.ERROR
        });
        reject(error);
      });
    });
  };
};
/**
 * Action to save the id of a clicked annotation
 * @param {string} annotationId - id of the clicked annotation
 * @return {object} action
 */


exports.contextCreateGuestUserSession = contextCreateGuestUserSession;

var contextResetGuestUserSession = function contextResetGuestUserSession() {
  return function (dispatch) {
    clearTimeout(expireSoonTimer);
    clearTimeout(expiredTimer);
    dispatch({
      type: _constants.CONTEXT_RESET_GUEST_USER_SESSION
    });
  };
};

exports.contextResetGuestUserSession = contextResetGuestUserSession;

var contextSetCommentsListMinimized = function contextSetCommentsListMinimized(value) {
  return {
    commentsListMinimized: value,
    type: _constants.CONTEXT_SET_COMMENTS_LIST_MINIMIZED
  };
};
/**
 * Action to initialize context state
 * @param {boolean} isPlacingAnnotation - new state for if currently placing an annotation
 * @param {string} itmId - the item that triggered annotation mode
 * @param {boolean} showAnnotationMask - new state for whether to show annotation mask or not
 * @param {boolean} newAnnotationType - type of annotation to be added
 * @return {object} action
 */


exports.contextSetCommentsListMinimized = contextSetCommentsListMinimized;

var contextSetAnnotationMode = function contextSetAnnotationMode(isPlacingAnnotation, itmId, showAnnotationMask, newAnnotationType) {
  return {
    isPlacingAnnotation: isPlacingAnnotation,
    itmId: itmId,
    showAnnotationMask: showAnnotationMask,
    newAnnotationType: newAnnotationType,
    type: _constants.CONTEXT_SET_ANNOTATION_MODE
  };
}; // TODO: Consolidate `contextSetAnnotationMode` and this into one action.


exports.contextSetAnnotationMode = contextSetAnnotationMode;

var toggleAnnotationMode = function toggleAnnotationMode(commentId, annotationType) {
  var compactLayout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return function (dispatch, getState) {
    var state = getState();
    var context = (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context"));
    var annotatingCommentChanged = context.annotatingItmId !== commentId;
    var isPlacingAnnotation = !context.isPlacingAnnotation || annotatingCommentChanged;

    if (compactLayout && !context.commentsListMinimized) {
      dispatch(contextSetCommentsListMinimized(true));
    }

    dispatch({
      itmId: isPlacingAnnotation ? commentId : undefined,
      isPlacingAnnotation: isPlacingAnnotation,
      showAnnotationMask: isPlacingAnnotation,
      newAnnotationType: annotationType,
      type: _constants.CONTEXT_SET_ANNOTATION_MODE
    });
  };
};
/**
 * Action to set the id of a comment associated with the selected annotation.
 * @param {string} id - comment id
 * @return {Object} action
 */


exports.toggleAnnotationMode = toggleAnnotationMode;

var setAnnotatingCommentId = function setAnnotatingCommentId(id) {
  return {
    id: id,
    type: _constants.SET_ANNOTATING_COMMENT_ID
  };
};
/**
 * Action to save the placed annotation location
 * @param {object} coordinates - coordinates for the new annotation
 * @param {object} nodeId - node ID for the annotation if it is something other than current node ID
 * @return {object} action
 */


exports.setAnnotatingCommentId = setAnnotatingCommentId;

var contextSaveAnnotationLocation = function contextSaveAnnotationLocation(coordinates, nodeId) {
  return {
    location: coordinates ? {
      coordinates: coordinates,
      nodeId: nodeId
    } : undefined,
    type: _constants.CONTEXT_SAVE_ANNOTATION_LOCATION
  };
};
/**
 * Action to save the placed annotation color
 * @param {object} color - color for the new annotation
 * @return {object} action
 */


exports.contextSaveAnnotationLocation = contextSaveAnnotationLocation;

var contextSaveAnnotationColor = function contextSaveAnnotationColor(color) {
  return {
    color: color,
    type: _constants.CONTEXT_SAVE_ANNOTATION_COLOR
  };
};
/**
 * Action to save location of focused input
 * @param {object} focusedInputInfo - object of information of input box which is in focus
 * @return {object} action
 */


exports.contextSaveAnnotationColor = contextSaveAnnotationColor;

var contextSaveFocusedInputInfo = function contextSaveFocusedInputInfo(focusedInputInfo) {
  return {
    focusedInputInfo: focusedInputInfo,
    type: _constants.CONTEXT_SAVE_FOCUSED_INPUT_INFO
  };
};
/**
 * Action to save the image coordinates information
 * @param {object} imageCoordinatesInfo - coordinates information for the image captured
 * @return {object} action
 */


exports.contextSaveFocusedInputInfo = contextSaveFocusedInputInfo;

var contextSaveImageCoordinatesInfo = function contextSaveImageCoordinatesInfo(imageCoordinatesInfo) {
  return {
    imageCoordinatesInfo: imageCoordinatesInfo,
    type: _constants.CONTEXT_SAVE_IMAGE_COORDINATES_INFO
  };
};
/**
 * Action to save the id of a clicked annotation
 * @param {string} annotationId - id of the clicked annotation
 * @return {object} action
 */


exports.contextSaveImageCoordinatesInfo = contextSaveImageCoordinatesInfo;

var contextSetClickedAnnotation = function contextSetClickedAnnotation(annotationId) {
  return function (dispatch) {
    dispatch({
      annotationId: annotationId,
      type: _constants.CONTEXT_SET_CLICKED_ANNOTATION
    });
  };
};
/**
 * Action to save the id of a comment to show
 * @param {string} cmtId - id of the comment to show
 * @return {object} action
 */


exports.contextSetClickedAnnotation = contextSetClickedAnnotation;

var contextSetShowCommentId = function contextSetShowCommentId(cmtId) {
  return {
    cmtId: cmtId,
    type: _constants.CONTEXT_SET_SHOW_COMMENT_ID
  };
};
/**
 * Action to register or un-register a section ID
 * @param {string} sectionId - id of the section of the annotation overlay
 * @param {boolean} isAdd - indication if this is a register or un-register action
 * @return {object} action
 */


exports.contextSetShowCommentId = contextSetShowCommentId;

var contextRegisterSectionId = function contextRegisterSectionId(sectionId) {
  var isAdd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return {
    sectionId: sectionId,
    isAdd: isAdd,
    type: _constants.CONTEXT_REGISTER_SECTION_ID
  };
};
/**
 * Action to set guest user login toast data
 * @param {Object} guestUserLoginToastInfo - new value of guest user login toast data
 * @return {undefined}
 */


exports.contextRegisterSectionId = contextRegisterSectionId;

var contextSetGuestUserLoginToastInfo = function contextSetGuestUserLoginToastInfo(guestUserLoginToastInfo) {
  return function (dispatch) {
    dispatch({
      data: guestUserLoginToastInfo,
      type: _constants.CONTEXT_SET_GUEST_USER_LOGIN_TOAST_INFO
    });
  };
};
/**
 * Action creator to enable/disable active unmapped section
 * @param {Object} value - new value of viewing unmapped section
 * @return {undefined}
 */


exports.contextSetGuestUserLoginToastInfo = contextSetGuestUserLoginToastInfo;

var contextSetUnmappedView = function contextSetUnmappedView(value) {
  return {
    type: _constants.CONTEXT_SET_UNMAPPED_VIEW,
    viewingUnmapped: value
  };
};

exports.contextSetUnmappedView = contextSetUnmappedView;